module.exports = __webpack_public_path__ + "img/LC.051fdeda.svg";